"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK = void 0;
const axios_1 = __importDefault(require("axios"));
const games_1 = require("../v1/api/games");
const tiers_1 = require("../v1/api/tiers");
const candidates_1 = require("../v1/api/candidates");
const members_1 = require("../v1/api/members");
const badges_1 = require("../v1/api/badges");
const awards_1 = require("../v1/api/awards");
const logs_1 = require("../v1/api/logs");
const races_1 = require("../v1/api/races");
const racePlayers_1 = require("../v1/api/racePlayers");
const seasons_1 = require("../v1/api/seasons");
const leaderboards_1 = require("./api/leaderboards");
const featured_1 = require("./api/featured");
const patrons_1 = require("./api/patrons");
const update_1 = require("./api/update");
class SDK {
    constructor(config) {
        this.getUpdateStatus = () => (0, update_1.getUpdateStatus)(this.BASE_URL);
        /*************************
         *         GAMES         *
         *************************/
        this.getGamesList = (args) => (0, games_1.getGamesList)(args, this.BASE_URL);
        this.getBadgesByGameIdList = (args) => (0, games_1.getBadgesByGameIdList)(args, this.BASE_URL);
        this.getGameCompletionList = (args) => (0, games_1.getGameCompletionList)(args, this.BASE_URL);
        /***************************
         *         MEMBERS         *
         ***************************/
        this.getMembersList = (args) => (0, members_1.getMembersList)(args, this.BASE_URL);
        this.getMemberById = (args) => (0, members_1.getMemberById)(args, this.BASE_URL);
        this.updateMemberById = (args) => (0, members_1.updateMemberById)(args, this.BASE_URL);
        this.getMemberGameList = (args) => (0, members_1.getMemberGameList)(args, this.BASE_URL);
        this.getMemberAchievementList = (args) => (0, members_1.getMemberAchievementList)(args, this.BASE_URL);
        this.updateMember = (args) => (0, update_1.updateMember)(args, this.BASE_URL);
        /*********************************
         *         TIERS         *
         *********************************/
        this.getTiersList = (args) => (0, tiers_1.getTiersList)(args, this.BASE_URL);
        /**************************
         *         BADGES         *
         **************************/
        this.getBadgesList = (args) => (0, badges_1.getBadgesList)(args, this.BASE_URL);
        this.createBadge = (args) => (0, badges_1.createBadge)(args, this.BASE_URL);
        this.getBadgeById = (args) => (0, badges_1.getBadgeById)(args, this.BASE_URL);
        this.updateBadgeById = (args) => (0, badges_1.updateBadgeById)(args, this.BASE_URL);
        this.deleteBadgeById = (args) => (0, badges_1.deleteBadgeById)(args, this.BASE_URL);
        /*********************************
         *         MEMBER BADGES         *
         *********************************/
        this.getMemberBadgeList = (args) => (0, members_1.getMemberBadgeList)(args, this.BASE_URL);
        this.giveBadgeToMemberById = (args) => (0, members_1.giveBadgeToMemberById)(args, this.BASE_URL);
        this.revokeBadgeFromMemberById = (args) => (0, members_1.revokeBadgeFromMemberById)(args, this.BASE_URL);
        /**************************
         *         AWARDS         *
         **************************/
        this.getAwardsList = (args) => (0, awards_1.getAwardsList)(args, this.BASE_URL);
        this.createAwardB = (args) => (0, awards_1.createAward)(args, this.BASE_URL);
        this.getAwardBById = (args) => (0, awards_1.getAwardById)(args, this.BASE_URL);
        this.updateAwardBById = (args) => (0, awards_1.updateAwardById)(args, this.BASE_URL);
        this.deleteAwardBById = (args) => (0, awards_1.deleteAwardById)(args, this.BASE_URL);
        /*********************************
         *         MEMBER AWARDS         *
         *********************************/
        this.getMemberAwardList = (args) => (0, members_1.getMemberAwardList)(args, this.BASE_URL);
        this.giveAwardToMemberById = (args) => (0, members_1.giveAwardToMemberById)(args, this.BASE_URL);
        this.revokeAwardFromMemberById = (args) => (0, members_1.revokeAwardFromMemberById)(args, this.BASE_URL);
        /********************
         *       LOGS       *
         *******************/
        this.createLog = (args) => (0, logs_1.createLog)(args, this.BASE_URL);
        this.getLogList = (args) => (0, logs_1.getLogList)(args, this.BASE_URL);
        /*********************
         *       RACES       *
         *********************/
        this.getRaceList = (args) => (0, races_1.getRaceList)(args, this.BASE_URL);
        this.createRace = (args) => (0, races_1.createRace)(args, this.BASE_URL);
        this.deleteRaceById = (args) => (0, races_1.deleteRaceById)(args, this.BASE_URL);
        this.updateRaceById = (args) => (0, races_1.updateRaceById)(args, this.BASE_URL);
        this.getRaceById = (args) => (0, races_1.getRaceById)(args, this.BASE_URL);
        this.getActiveRace = () => (0, races_1.getActiveRace)(this.BASE_URL);
        this.updateRaceRatingById = (args) => (0, races_1.updateRaceRatingById)(args, this.BASE_URL);
        /*********************************
         *       RACE PARTICIPANTS       *
         *********************************/
        this.getRaceParticipantById = (args) => (0, racePlayers_1.getRaceParticipantById)(args, this.BASE_URL);
        this.getRaceParticipantsList = (args) => (0, racePlayers_1.getRaceParticipantsList)(args, this.BASE_URL);
        this.joinRaceByParticipantId = (args) => (0, racePlayers_1.joinRaceByParticipantId)(args, this.BASE_URL);
        this.updateRaceByParticipantId = (args) => (0, racePlayers_1.updateRaceByParticipantId)(args, this.BASE_URL);
        /***********************
         *       SEASONS       *
         ***********************/
        this.createSeason = (args) => (0, seasons_1.createSeason)(args, this.BASE_URL);
        this.getSeasonById = (args) => (0, seasons_1.getSeasonById)(args, this.BASE_URL);
        this.updateSeasonById = (args) => (0, seasons_1.updateSeasonById)(args, this.BASE_URL);
        this.startSeasonById = (args) => (0, seasons_1.startSeasonById)(args, this.BASE_URL);
        this.endSeasonById = (args) => (0, seasons_1.endSeasonById)(args, this.BASE_URL);
        this.getSeasonsList = (args) => (0, seasons_1.getSeasonsList)(args, this.BASE_URL);
        this.getSeasonLeaderboardsById = (args) => (0, seasons_1.getSeasonLeaderboardsById)(args, this.BASE_URL);
        /****************************
         *       LEADERBOARDS       *
         ****************************/
        this.getLeaderboardsMembersList = (args) => (0, leaderboards_1.getLeaderboardsMembersList)(args, this.BASE_URL);
        this.getLeaderboardsGamesList = (args) => (0, leaderboards_1.getLeaderboardsGamesList)(args, this.BASE_URL);
        this.getMemberLeaderboardsPositionById = (args) => (0, leaderboards_1.getMemberLeaderboardsPositionById)(args, this.BASE_URL);
        /************************
         *       FEATURED       *
         ************************/
        this.createFeatured = (args) => (0, featured_1.createFeatured)(args, this.BASE_URL);
        this.getFeaturedList = (args) => (0, featured_1.getFeaturedList)(args, this.BASE_URL);
        this.updateFeaturedById = (args) => (0, featured_1.updateFeaturedById)(args, this.BASE_URL);
        this.deleteFeaturedById = (args) => (0, featured_1.deleteFeaturedById)(args, this.BASE_URL);
        /***********************
         *       PATRONS       *
         ***********************/
        this.createPatron = (args) => (0, patrons_1.createPatron)(args, this.BASE_URL);
        this.getPatronsList = (args) => (0, patrons_1.getPatronsList)(args, this.BASE_URL);
        this.updatePatronById = (args) => (0, patrons_1.updatePatronById)(args, this.BASE_URL);
        this.getPatreonTierList = () => (0, patrons_1.getPatreonTierList)(this.BASE_URL);
        /**************************
         *       CANDIDATES       *
         **************************/
        this.getCandidateSummary = (args) => (0, candidates_1.getCandidateSummary)(args, this.BASE_URL);
        this.BASE_URL = `${config.host}/api/v1`;
        if (config.authToken) {
            axios_1.default.defaults.headers.common['Authorization'] = config.authToken;
        }
        else {
            throw new Error('Authorization token is required.');
        }
    }
}
exports.SDK = SDK;
